import React from 'react';
// import './Music.css';
// import Navbar from '../components/meditation/navbar';
import MeditationCard from '../components/meditation/meditationcard';


const Meditation = () => {
  return (
      <div className="meditation-container">
       <MeditationCard></MeditationCard>
      </div>
    
  );
};

export default Meditation;
